import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {AffiliateService} from '../../affiliate.service';
import {Constants} from '../../../../shared/utils/constants';
import {NgForm} from '@angular/forms';
import {AppService} from '../../../../app.service';

declare var $: any;

@Component({
  selector: 'fx-ib-level',
  templateUrl: './ib-level.component.html',
  styleUrls: ['./ib-level.component.sass']
})
export class IbLevelComponent implements OnInit, AfterViewInit {
  @ViewChild('form') form: NgForm;
  @Input() config;
  @Input() permission;
  setting: any = {};
  ibSettings = [];
  listIBConfig = [];
  configManageIB: any = {};
  currentUserIdConfig = null;
  isEdit = false;
  currentIndexEdit = null;
  keyword = '';
  constructor(
    private service: AffiliateService,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.getListIBSetting();
  }
  search(event): void {
    if (event) {
      if (event.keyCode === 13) {
        this.getListIBSetting();
      }
    } else {
      this.getListIBSetting();
    }
  }
  private getListIBSetting(): void {
    const option = {
      q: (this.keyword) ? encodeURIComponent((this.keyword).trim()) : this.keyword
    };
    this.service.getListIBSetting(option)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.ibSettings = res.data;
          this.onLoadDataById();
        }
      });
  }

  onSubmitSetting(): void {
    if (this.form.valid) {
      const body = {
        user_id: this.setting.userId,
        group_config_id: this.setting.group,
        // commission: this.setting.commission / 100,
        // rate: this.setting.rate / 100,
        // pip: this.setting.pip
      };
      this.service.addConfigIbSetting(body)
        .subscribe(res => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.appService.showSuccess('Add Ib setting success');
            $('#modalIbLevelSetting .close').trigger('click');
            this.getListIBSetting();
          } else {
            this.appService.showError(res.error_code);
          }
        });
    }
  }
  onCampaignSetting(item): void {
    this.setting.userId = item.id;
    const existConfig = item.groups.map(v => v.id);
    this.listIBConfig = this.config.filter(v => !existConfig.includes(v.id));
    this.form.onReset();
  }
  getManageIBInfo(item): void {
    const newItem = JSON.parse(JSON.stringify(item));
    this.currentUserIdConfig = newItem.id;
    const listGroups =  newItem.groups.map(v => {
      v.data.commission = (v.data.commission) ? +((v.data.commission * 100).toPrecision(2)) : v.data.commission;
      v.data.rate = (v.data.rate) ? +((v.data.rate * 100).toPrecision(2)) : v.data.rate;
      return v;
    });
    this.configManageIB = {
      name: newItem.email,
      data: listGroups
    };
  }
  onEdit(item): void {
    if (item) {
      this.isEdit = true;
      this.currentIndexEdit = item.IBGroupId;
    } else {
      this.isEdit = false;
      this.currentIndexEdit = null;
      this.getListIBSetting();
    }
  }
  onLoadDataById(): void {
    const item = this.ibSettings.find(v => v.id === this.currentUserIdConfig) || null;
    if (item) {
      const newItem = JSON.parse(JSON.stringify(item));
      const updateGroups =  newItem.groups.map(v => {
        v.data.commission = (v.data.commission) ? +((v.data.commission * 100).toPrecision(2)) : v.data.commission;
        v.data.rate = (v.data.rate) ? +((v.data.rate * 100).toPrecision(2)) : v.data.rate;
        return v;
      });
      this.configManageIB = {
        name: newItem.email,
        data: updateGroups
      };
    }
  }
  onSave(item): void {
    const body = {
      ib_groups_id: item.IBGroupId,
      pip: item.data.pip,
      commission: (item.data.commission / 100)
    };
    this.service.updateConfigIbSetting(body)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess('Update config setting success');
          this.isEdit = false;
          this.currentIndexEdit = null;
        } else {
          this.appService.showError(res.error_code);
        }
      });
  }
  ngAfterViewInit(): void {
    $('#modalManageIB').on('hide.bs.modal', () => {
      localStorage.setItem('un_loading', 'true');
      this.getListIBSetting();
    });
  }
}
